import { render, staticRenderFns } from "./DocumentShareMultipleModal.vue?vue&type=template&id=6ad9b05e&scoped=true&"
import script from "./DocumentShareMultipleModal.vue?vue&type=script&lang=js&"
export * from "./DocumentShareMultipleModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentShareMultipleModal.vue?vue&type=style&index=0&id=6ad9b05e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad9b05e",
  null
  
)

export default component.exports